import { Types } from "common/createjs";
import { noop } from "common/functions";
import log from "loglevel";
import * as R from "ramda";
const relative = {
    create: (scene, relativePath, option) => {
        return {
            name: "relative",
            scene,
            relativePath,
            preloadjsId: option === null || option === void 0 ? void 0 : option.preloadjsId,
            type: option === null || option === void 0 ? void 0 : option.type,
        };
    },
};
const url = {
    create: (scene, url, preloadjsId) => {
        return {
            name: "url",
            scene,
            url,
            preloadjsId,
        };
    },
};
export const resourcesRoot = "https://yawhwovwwvpv6066961.cdn.ntruss.com";
//const resourcesRoot = "https://kr.object.ncloudstorage.com/bigkingtravel";
export const soundPath = toRootPath("오디오 스프라이트 수정.mp3");
export const openingSoundPath = toPath("opening", "오프닝 오디오스프라이트.mp3");
export const chatbotSoundPath = toPath("chatbot", "챗봇 오디오 스프라이트.mp3");
export const announceSoundPath = toPath("announce", "안내방송 오디오 스프라이트.mp3");
export const loadingSoundPath = toPath("loading", "로딩 오디오스프라이트.mp3");
export const video360SoundPath = toPath("360video", "360 오디오스프라이트.m4a");
export function toRootPath(fileName) {
    return `${resourcesRoot}/${fileName}`;
}
export function toPath(folder, fileName) {
    return `${resourcesRoot}/${folder}/${fileName}`;
}
export const fileNames = {
    preOpeningGif: relative.create("opening", "프리-오프닝 아이콘.gif"),
    openingTurnOnSound: relative.create("opening", "오프닝 안내문 8:10.png"),
    openingMainGif: relative.create("opening", "메인.gif"),
    openingPopupGif: relative.create("opening", "팝업.gif"),
    openingClicked: relative.create("opening", "아이콘반전.png"),
    chatbotLoading: relative.create("chatbot", "챗봇 로딩.gif"),
    chatbotIconGif: relative.create("chatbot", "아이콘1.gif"),
    chatbotTicket1Gif: relative.create("chatbot", "티켓1.gif"),
    chatbotTicket2Gif: relative.create("chatbot", "티켓2.gif"),
    chatbotTicket3Gif: relative.create("chatbot", "티켓3.gif"),
    chatbotLayoutGif1: relative.create("chatbot", "챗봇 레이아웃1.png"),
    chatbotLayoutGif2: relative.create("chatbot", "챗봇 레이아웃2.png"),
    chatbotLayoutGif3: relative.create("chatbot", "챗봇 레이아웃3.gif"),
    chatbotTransitionGif: relative.create("chatbot", "트랜지션.gif"),
    chatbotNatashaGif: relative.create("chatbot", "나타샤.gif"),
    chatbotNatashaIcon: relative.create("chatbot", "나타샤아이콘.png"),
    announceBackgroundGif: relative.create("announce", "배경.gif"),
    announceVideo: relative.create("announce", "안내방송.mp4"),
    announceTicketGif: relative.create("announce", "티켓 아이콘.gif"),
    announceYes: relative.create("announce", "y.gif"),
    loadingWaitingGif: relative.create("loading", "대기1.gif"),
    loadingBar: relative.create("loading", "로딩바.png"),
    video360Notice: relative.create("360video", "안내 팝업.gif"),
    video360NoticePermission: relative.create("360video", "안내 팝업 버튼 1.png"),
    video360NoticeStart: relative.create("360video", "안내 팝업 버튼 2.gif"),
    video360SelfieIcon: relative.create("360video", "셀카모드 아이콘.gif"),
    video360CameraLayerTop: relative.create("360video", "카메라-레이어_0000_Layer-2.png"),
    video360CameraLayerBottom: relative.create("360video", "카메라-레이어_0001_Layer-1.png"),
    video360CameraLayerBottomForSelfie: relative.create("360video", "카메라 레이어3.png"),
    video360Caption: relative.create("360video", "360 비디오 자막.vtt", {
        preloadjsId: "360video.vtt",
        type: Types.TEXT,
    }),
    video360AframeSrc: url.create("360video", "https://unpkg.com/aframe@1.0.4/dist/aframe-v1.0.4.min.js", "aframeSrc"),
    video360TheVideo: relative.create("360video", ["360video.webm", "360videosample.mp4"], {
        preloadjsId: "360video",
        type: Types.VIDEO,
    }),
    video360TimelineBarLong: relative.create("360video", "타임라인바_0000_Layer-5-copy-min.png"),
    video360TimelineBarShort: relative.create("360video", "타임라인바1-min.png"),
    video360TimelineBarBackground: relative.create("360video", "타임라인바_0001_Layer-5-min.png"),
    video360ChalkakSound: relative.create("360video", "360 카메라 사운드.m4a"),
    video360VideoLoadingPaused: relative.create("360video", "앗잠시만.png"),
};
export const paths = R.map((scenePath) => {
    switch (scenePath.name) {
        case "relative":
            if (typeof scenePath.relativePath === "string") {
                return toPath(scenePath.scene, scenePath.relativePath);
            }
            else {
                return scenePath.relativePath.map((path) => toPath(scenePath.scene, path));
            }
        case "url":
            if (scenePath.preloadjsId) {
                log.trace("preloadjsId", scenePath.preloadjsId);
                return {
                    src: scenePath.url,
                    id: scenePath.preloadjsId,
                };
            }
            else {
                return scenePath.url;
            }
    }
}, fileNames);
const completePath = R.map((scenePath) => {
    switch (scenePath.name) {
        case "relative":
            if (scenePath.preloadjsId) {
                if (typeof scenePath.relativePath === "string") {
                    return {
                        src: toPath(scenePath.scene, scenePath.relativePath),
                        type: scenePath.type,
                        id: scenePath.preloadjsId,
                    };
                }
                else {
                    return scenePath.relativePath.map((path) => ({
                        src: toPath(scenePath.scene, path),
                        type: scenePath.type,
                        id: scenePath.preloadjsId,
                    }));
                }
            }
            else {
                if (typeof scenePath.relativePath === "string") {
                    return toPath(scenePath.scene, scenePath.relativePath);
                }
                else {
                    return scenePath.relativePath.map((path) => toPath(scenePath.scene, path));
                }
            }
        case "url":
            if (scenePath.preloadjsId) {
                log.trace("preloadjsId", scenePath.preloadjsId);
                return {
                    src: scenePath.url,
                    id: scenePath.preloadjsId,
                };
            }
            else {
                return scenePath.url;
            }
    }
});
const filterMaker = (folderToFind) => R.filter((scenePath) => {
    return scenePath.scene === folderToFind;
});
const filterOpening = filterMaker("opening");
const filterChatbot = filterMaker("chatbot");
const filterAnnounce = filterMaker("announce");
const filterLoading = filterMaker("loading");
const filter360Video = filterMaker("360video");
// const toOpeningPath = R.partial(toPath, ["opening"]);
// const toChatbotPath = R.partial(toPath, ["chatbot"]);
// const toAnnouncePath = R.partial(toPath, ["announce"]);
// const toLoadingPath = R.partial(toPath, ["loading"]);
// const to360VideoPath = R.partial(toPath, ["360video"]);
const getOpeningPaths = R.compose(
// R.map(toOpeningPath),
completePath, filterOpening, R.values);
export const openingPaths = getOpeningPaths(fileNames);
const getChatbotPaths = R.compose(completePath, filterChatbot, R.values);
export const chatbotPaths = getChatbotPaths(fileNames);
const getAnnouncePaths = R.compose(completePath, filterAnnounce, R.values);
export const announcePaths = getAnnouncePaths(fileNames);
const getLoadingPaths = R.compose(completePath, filterLoading, R.values);
export const loadingPaths = getLoadingPaths(fileNames);
const get360VideoPaths = R.compose(completePath, filter360Video, R.values);
export const video360Paths = get360VideoPaths(fileNames);
export var smartVideo;
(function (smartVideo) {
    const get360VideoPaths = R.compose(completePath, filter360Video);
    smartVideo.video360Paths = get360VideoPaths(fileNames);
    smartVideo.defaultConvert = (path) => {
        let first;
        if (Array.isArray(path)) {
            first = path[0];
        }
        else {
            first = path;
        }
        if (typeof first === "string") {
            return {
                name: "normal",
                path: first,
                onComplete: noop,
                onProgress: noop,
            };
        }
        const { type } = first;
        if (type === Types.VIDEO) {
            return {
                name: "video",
                path,
                onProgress: noop,
                onXHRFinished: noop,
                videoTagPrepare: () => {
                    return null;
                },
                method: "xhr",
            };
        }
        else {
            return {
                name: "normal",
                path: first,
                onProgress: noop,
                onComplete: noop,
            };
        }
    };
    smartVideo.video360FileLoadArgs = R.map(smartVideo.defaultConvert, smartVideo.video360Paths);
})(smartVideo || (smartVideo = {}));
export const test = {
    completePath,
    filterOpening,
    getOpeningPaths,
    relative,
};
//# sourceMappingURL=resources.js.map